import { render } from "./End.vue?vue&type=template&id=5adb0115&lang=pug"
import script from "./End.vue?vue&type=script&setup=true&lang=js"
export * from "./End.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__